<template>
  <div>
    <el-form 
      ref="form" 
      :model="form" 
      label-width="100px"
      :rules="rules"
      @submit.native.prevent
    >
      <el-form-item label="转化名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入转换名称"></el-input>
      </el-form-item>
    </el-form>
    <div class="btns">
      <el-button @click="$emit('close')">取消</el-button>
      <el-button type="primary"  @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import { validEmoji } from '@/utils/validate'
export default {
  props: ['cbs' ],
  data() {
    const validateName = (rule, value, callback) => {
        if (validEmoji(value)) {
          callback(new Error('不可输入表情'));
        } else {
          callback();
        }
      };
    return {
      form: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入转化名称', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' },
          { max: 15, message: '不可超过15字', trigger: 'change' },
        ]
      }
    }
  },
  methods: {
    onSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.cbs.onSubmit(this.form.name)
          } else {
            return false;
          }
        });
      
    }
  }
}
</script>

<style lang="scss" scoped>

.btns {
  margin-top: 25px;
  text-align: center;
}

</style>